<template>
  <el-form :model="brandModuleData" ref="warehouseForm" label-width="15%" class="demo-warehouseForm">
    <el-form-item :label="generateCustomizeString('brand')">
      <el-select v-model="brandId" :placeholder="generateCustomizeString('selectBrand')">
        <el-option v-for="item in brandOptions" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item :label="generateCustomizeString('sortWeight')">
      <el-input v-model="brandModuleData.sort_by"></el-input>
    </el-form-item>

    <el-form-item :label="generateCustomizeString('isShow')">
      <el-switch v-model="brandModuleData.is_show" :active-text="generateCustomizeString('moduleReady')" :inactive-text="generateCustomizeString('moduleWaitForReview')"></el-switch>
    </el-form-item>

    <el-form-item>
      <el-button v-if="isEdit" type="primary" @click="updateClick" plain>{{generateCustomizeString('update')}} </el-button>
      <el-button v-if="!isEdit" type="primary" @click="createClick">{{generateCustomizeString('create')}}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

const defaultBrandModule = {
  related_data: [],
  sort_by: 0,
  type: 5,
  cms_home_category_id: 0,
  is_show: false
}

export default {
  name: 'BrandModuleDetail',

  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    isView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      brandModuleData: Object.assign({}, defaultBrandModule),
      brandOptions: []
    }
  },
  methods: {
    generateCustomizeString,
    createClick() {
      this.createBrandModule()
    },
    updateClick() {
      this.updateBrandModule()
    },
    fetchBrand() {
      return new Promise((resolve, reject) => {
        request({
          url: '/brands?pages=all',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = response.data[i].id
              obj.label = response.data[i].brand_name
              data[i] = obj
            }
            this.brandOptions = data
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    createBrandModule() {
      var data = {
        related_data: this.brandModuleData.related_data,
        sort_by: this.brandModuleData.sort_by,
        type: 5,
        cms_home_category_id: this.$route.params.cms_home_category_id,
        is_show: this.brandModuleData.is_show
      }
      request({
        url: 'cms-category-item',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('createdSuccessfully'),
              type: 'success'
            })
            this.$router.push({
              name: 'PcBrandModule',
              params: {
                cms_home_category_id: this.$route.params.cms_home_category_id
              }
            })
          } else {
            this.$message.error(this.generateCustomizeString('createFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('createFailed'))
        })
    },
    fetchBrandModel() {
      request({
        url: 'cms-category-item/' + this.$route.params.categoryId,
        method: 'get'
      })
        .then(res => {
          if (res.status === 0) {
            // 更新数据
            for (const i in this.brandModuleData) {
              this.brandModuleData[i] = res.data[i]
              if (i === 'is_show') {
                this.brandModuleData.is_show = res.data[i] === 1
              }
            }
            console.log(this.brandModuleData)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateBrandModule() {
      var data = {
        related_data: this.brandModuleData.related_data,
        sort_by: this.brandModuleData.sort_by,
        type: 5,
        cms_home_category_id: this.$route.params.cms_home_category_id,
        is_show: this.brandModuleData.is_show
      }
      request({
        url: 'cms-category-item/' + this.$route.params.categoryId,
        method: 'put',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('updateSuccessfully'),
              type: 'success'
            })
            this.$router.push({
              name: 'PcBrandModule',
              params: {
                cms_home_category_id: this.$route.params.cms_home_category_id
              }
            })
          } else {
            this.$message.error(this.generateCustomizeString('createFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('createFailed'))
        })
    }
  },

  created() {
    this.fetchLoding = true
    Promise.all([this.fetchBrand()])
      .then(result => {})
      .catch(error => {
        console.warn(error)
      })
      .finally(() => {
        this.fetchLoding = false
      })
    if (this.isEdit) {
      this.fetchNavigate()
    } else {
      this.brandModuleData = Object.assign({}, defaultBrandModule)
    }
  },
  computed: {
    brandId: {
      get: function() {
        return this.brandModuleData.related_data[0]
      },
      set: function(newValue) {
        this.brandModuleData.related_data = [newValue]
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.demo-warehouseForm {
  padding: 50px 50px 0px 50px;
}
</style>
